module.exports = __webpack_public_path__ + "static/media/anni_static_bg_bottom.52477c7f.png";